import { TabStyles } from '@tableau/widgets';

export module SiteSettingsStyles {
  export const HeaderStyle: React.CSSProperties = {
    fontFamily: 'BentonSans-Medium, Arial, Helvetica, sans-serif',
    fontSize: 15,
  };

  export const DisabledLink: React.CSSProperties = {
    color: TabStyles.Typography.Color.Disabled,
  };

  export const BodyStyle: React.CSSProperties = {
    paddingLeft: '18px',
    paddingBottom: '18px',
  };

  export const CheckboxStyle: React.CSSProperties = {
    marginLeft: '-6px',
  };
}
